const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  API_BASE_URL: process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/api` : 'http://localhost:3000/api',
};

export default config;
